import { createSlice } from "@reduxjs/toolkit";

const invoicePenaltyUserNotificationsSlice = createSlice({
  name: "invoicePenaltyUserNotifications",

  initialState: {
    notifications: [],
    total: 0,
    loading: false,
    error: null,
    pendingNotifications: [],
    pendingTotal: 0,
    pendingLoading: false,
    pendingError: null,
  },

  reducers: {
    // FETCH VISIBLE
    fetchInvoicePenaltyUserNotificationsStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchInvoicePenaltyUserNotificationsSuccess: (state, action) => {
      state.notifications = action.payload.notifications || [];
      state.total = action.payload.total || 0;
      state.loading = false;
      state.error = null;
    },

    fetchInvoicePenaltyUserNotificationsFailure: (state) => {
      state.loading = false;
      state.error = "Error fetching invoice penalty notifications";
      state.notifications = [];
      state.total = 0;
    },

    // FETCH OPERATIONAL PENDING
    fetchPendingInvoicePenaltyUserNotificationsStart: (state) => {
      state.pendingLoading = true;
      state.pendingError = null;
    },

    fetchPendingInvoicePenaltyUserNotificationsSuccess: (state, action) => {
      state.pendingNotifications = action.payload.notifications || [];
      state.pendingTotal = action.payload.total || 0;
      state.pendingLoading = false;
      state.pendingError = null;
    },

    fetchPendingInvoicePenaltyUserNotificationsFailure: (state) => {
      state.pendingLoading = false;
      state.pendingError = "Error fetching pending invoice penalties";
      state.pendingNotifications = [];
      state.pendingTotal = 0;
    },

    // DISMISS
    dismissAllStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    dismissAllSuccess: (state, action) => {
      const dismissedIds = new Set(action.payload || []);
      state.notifications = state.notifications.filter(
        (notification) => !dismissedIds.has(notification.id),
      );
      state.total = state.notifications.length;
      state.pendingNotifications = state.pendingNotifications.filter(
        (notification) => !dismissedIds.has(notification.id),
      );
      state.pendingTotal = state.pendingNotifications.length;
      state.loading = false;
      state.error = null;
    },

    dismissAllFailure: (state) => {
      state.loading = false;
      state.error = "Error dismissing invoice penalty notifications";
    },

    // REMIND LATER
    remindLaterAllStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    remindLaterAllSuccess: (state, action) => {
      const remindedIds = new Set(action.payload || []);
      state.notifications = state.notifications.filter(
        (notification) => !remindedIds.has(notification.id),
      );
      state.total = state.notifications.length;
      state.pendingNotifications = state.pendingNotifications.map(
        (notification) => remindedIds.has(notification.id)
          ? { ...notification, status: "remind_later" }
          : notification,
      );
      state.loading = false;
      state.error = null;
    },

    remindLaterAllFailure: (state) => {
      state.loading = false;
      state.error = "Error setting remind later";
    },

    // LOGOUT
    logoutInvoicePenaltyUserNotifications: (state) => {
      state.notifications = [];
      state.total = 0;
      state.loading = false;
      state.error = null;
      state.pendingNotifications = [];
      state.pendingTotal = 0;
      state.pendingLoading = false;
      state.pendingError = null;
    },
  },
});

export const {
  fetchInvoicePenaltyUserNotificationsStart,
  fetchInvoicePenaltyUserNotificationsSuccess,
  fetchInvoicePenaltyUserNotificationsFailure,

  fetchPendingInvoicePenaltyUserNotificationsStart,
  fetchPendingInvoicePenaltyUserNotificationsSuccess,
  fetchPendingInvoicePenaltyUserNotificationsFailure,

  dismissAllStart,
  dismissAllSuccess,
  dismissAllFailure,

  remindLaterAllStart,
  remindLaterAllSuccess,
  remindLaterAllFailure,

  logoutInvoicePenaltyUserNotifications,
} = invoicePenaltyUserNotificationsSlice.actions;

export default invoicePenaltyUserNotificationsSlice.reducer;
